import * as tslib_1 from "tslib";
import { Input } from '@angular/core';
import { ComponentMessages } from '@progress/kendo-angular-l10n';
/**
 * @hidden
 */
var Messages = /** @class */ (function (_super) {
    tslib_1.__extends(Messages, _super);
    function Messages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Messages.propDecorators = {
        'decrement': [{ type: Input },],
        'increment': [{ type: Input },],
        'dragHandle': [{ type: Input },],
    };
    return Messages;
}(ComponentMessages));
export { Messages };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-inputs/dist/es/slider/localization/messages.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/slider/localization/messages.js
// module chunks = vendor